module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('h2', [_c('span', {
    staticClass: "h2-inner"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('blockquote', {
    staticClass: " bq"
  }, [_c('p', {
    staticClass: " firstInSection"
  }, [_vm._v("“I think the New Modellers knead all their dough with ale for I have never seen so many drunk in my life in so such a short a time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "source firstInSection"
  }, [_vm._v("Sir Samuel Luke, Parliamentary Governor of Newport Pagnell, on seeing troops from the New Model Army for the first time")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 69
// module chunks = 0